import { LazyWrapper } from 'components/LazyWrapper/LazyWrapper'
import { navigateToExternalUrl } from 'utils/location'
import { useIsBlaze } from 'hooks/useIsBlaze'

const WebflowHostedPage = (path: string) => {
  const isBlaze = useIsBlaze()
  const url = isBlaze ? `https://get.blaze.ai${path}` : `https://get.almanac.io${path}`

  const component = () => {
    navigateToExternalUrl(url)

    return <div />
  }

  return LazyWrapper(component)
}

export default WebflowHostedPage
